import axios from "axios";

export const portalApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cocoa_portal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function portalError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
